import { webSocketApiUrlsDictionary } from '../constants';
import { getToken } from './authentication';

const defaultUrl =
  process.env.REACT_APP_API_URL || `${window.location.origin}/api/v1/`;

const theme = localStorage.getItem('theme');

const BACKEND_API_ENDPOINT =
  webSocketApiUrlsDictionary[theme]?.apiUrl || defaultUrl;

export const API_KEY = 'api-key';

const defaultHeaders = {
  Accept: 'text/plain',
  'Content-Type': 'text/plain;charset=iso-8859-1',
  'Accept-Language': 'pt-BR',
  Platform: 'DASHBOARD',
  'Api-Key': localStorage.getItem(API_KEY),
};

/**
 * Does a request to the backend API corresponding to defined options
 * @param {String} url The url to make the request
 * @param {Object} options The object containing defined request options
 */
const doRawRequest = async (url, options) => {
  const { method, body } = options;

  try {
    const authToken = getToken();

    if (authToken) defaultHeaders.Authorization = `${authToken}`;

    const raw = await fetch(BACKEND_API_ENDPOINT + url, {
      method,
      headers: defaultHeaders,
      body,
    });

    return raw.text();
  } catch {
    return {};
  }
};

export default doRawRequest;
